var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 89,
    viewBox: "0 0 163 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.64343H9.53554V18.283H1V6.64343Z",
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4C1 2.34314 2.34315 1 4 1H9.53554V6.64341H1V4Z",
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8218 6.64343H162.108V18.283H85.8218V6.64343Z",
    fill: "#F5F5F5",
    stroke: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8218 1H159.108C160.765 1 162.108 2.34315 162.108 4V6.64341H85.8218V1Z",
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18.283,
    width: 8.53554,
    height: 11.6395,
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8218,
    y: 18.283,
    width: 76.2864,
    height: 11.6395,
    fill: "white",
    stroke: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 29.9225,
    width: 8.53554,
    height: 11.6395,
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8218,
    y: 29.9225,
    width: 76.2864,
    height: 11.6395,
    fill: "white",
    stroke: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 41.562,
    width: 8.53554,
    height: 11.6395,
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8218,
    y: 41.562,
    width: 76.2864,
    height: 11.6395,
    fill: "white",
    stroke: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 53.2015,
    width: 8.53554,
    height: 11.6395,
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8218,
    y: 53.2015,
    width: 76.2864,
    height: 11.6395,
    fill: "white",
    stroke: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 64.8411,
    width: 8.53554,
    height: 11.6395,
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8218,
    y: 64.8411,
    width: 76.2864,
    height: 11.6395,
    fill: "white",
    stroke: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 76.4806,
    width: 8.53554,
    height: 11.6395,
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8218,
    y: 76.4806,
    width: 76.2864,
    height: 11.6395,
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_8225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 7H86V19H10V7Z",
    fill: "#E6F7FF",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1H86V7H10V1Z",
    fill: "#F0F0F0",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    width: 76,
    height: 11,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 76,
    height: 11,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 41,
    width: 76,
    height: 12,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 53,
    width: 76,
    height: 12,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 65,
    width: 76,
    height: 12,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 77,
    width: 76,
    height: 11,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 64,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 45,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 45,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 57,
    width: 45,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 69,
    width: 59,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 81,
    width: 45,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 76,
    height: 86.7833,
    stroke: "#1890FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3574,
    y: 10.876,
    width: 59.7488,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3574,
    y: 22.5155,
    width: 38.9434,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3574,
    y: 34.155,
    width: 34.1422,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3574,
    y: 45.7946,
    width: 59.7488,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3574,
    y: 57.4341,
    width: 34.1422,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3574,
    y: 69.0736,
    width: 43.7446,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3574,
    y: 80.7131,
    width: 36.8095,
    height: 3,
    rx: 1.5,
    fill: "#BFBFBF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 88,
    width: 87,
    height: 162,
    transform: "rotate(-90 1 88)",
    fill: "url(#paint0_linear_184_8225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_8225",
    x1: 44.5,
    y1: 88,
    x2: 44.5,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.746326,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_8225"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 76,
    height: 86.7833,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyUpload);
export default __webpack_public_path__ + "static/media/survey-upload.f718ef6451da778009eff41c423f5149.svg";
export { ForwardRef as ReactComponent };